import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background-50 px-4 text-center">
      <h1 className="pointer-events-none absolute bottom-0 select-none text-[9rem] font-black text-background-100 md:text-[14rem]">
        404
      </h1>
      <div className="relative z-10">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
          <i className="ri-error-warning-line"></i> 页面走丢了
        </span>
        <h2 className="mt-4 font-display text-2xl font-black text-foreground-900 md:text-3xl">没有找到这个页面</h2>
        <p className="mt-2 font-mono text-sm text-foreground-400">{location.pathname}</p>
        <p className="mt-3 text-sm text-foreground-600">该页面不存在或已被移动，回到首页继续探索漫画吧。</p>
        <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i> 返回首页
          </Link>
          <Link
            to="/category/all"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/60 px-6 py-3 text-sm font-semibold text-foreground-700 hover:bg-background-100"
          >
            浏览漫画大全
          </Link>
        </div>
      </div>
    </div>
  );
}